import { createContext, useContext } from "react";

// Contexto del módulo Notas: notas flotantes y la ventanita «¿por dónde llamar?». El proveedor vive en components/notas/NotasProvider.jsx.
// Sin proveedor (p. ej. en pruebas de un componente suelto) las acciones no hacen nada, nunca rompen.
const NOOP = {
  flotantes: [],
  abrirFlotante: () => {}, cerrarFlotante: () => {}, minimizarFlotante: () => {}, moverFlotante: () => {}, traerAlFrente: () => {},
  pedirLlamada: () => {}, enviarAAparte: () => {},
};
export const NotasContext = createContext(null);
export const useNotas = () => useContext(NotasContext) || NOOP;
